/* nan — cart-driven UI refresh (free shipping bar + header total) */
(function () {
  var THRESHOLD = 175000; // 1,750.00 TL in kuruş — update if the free-shipping threshold changes

  function formatTL(cents) {
    var v = (cents / 100).toFixed(2); // "1750.00"
    var parts = v.split(".");
    return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",") + "." + parts[1] + " TL";
  }

  function refresh() {
    fetch("/cart.js")
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        // Free shipping bar
        var span = document.querySelector(".free-shipping__text [data-js-text]");
        if (span) {
          var remaining = THRESHOLD - cart.total_price;
          span.textContent = remaining > 0
            ? "Ücretsiz kargo için " + formatTL(remaining)
            : "Ücretsiz kargo kazandınız!";
        }
// Header cart total
        var headerTotal = document.querySelector(".nan-cart__total");
        if (headerTotal) headerTotal.textContent = formatTL(cart.total_price);
});
  }

  // Re-run after any cart mutation (add/change/update via ajax)
  var origFetch = window.fetch;
  window.fetch = function () {
    var url = String(arguments[0]);
    var p = origFetch.apply(this, arguments);
    if (/\/cart\/(add|change|update|clear)/.test(url)) p.then(function () { setTimeout(refresh, 300); });
    return p;
  };
  var origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (m, url) {
    if (/\/cart\/(add|change|update|clear)/.test(String(url))) {
      this.addEventListener("load", function () { setTimeout(refresh, 300); });
    }
    return origOpen.apply(this, arguments);
  };
})();